import {Modal} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import {type PropsWithChildren, type ReactElement, memo} from 'react'

import * as classes from './FullscreenPanelBody.classes'

type Props = PropsWithChildren<{
  className?: string
}>

export const FullscreenPanelBody = memo<Props>(function FullscreenPanelBody(props: Props): ReactElement {
  const {className} = props

  return <Modal.Body p={undefined} {...props} className={clsx(classes.body, className)} />
})
